<template>
  <b-container fluid>
    <div class="mt-2">
      <el-card shadow="always">
        <div style="font-size: 14px; color: #606266">
          <span>No：{{ formData.recommendNo }}</span>
          <el-divider direction="vertical"></el-divider>
          <span
            >Status：{{
              formData.recommendStatus === 'Y' ? '已推荐' : '新增'
            }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span
            >Create：{{ formData.createByName }} at
            {{ formData.createDate }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span
            >Modify：{{ formData.modifyByName }} at
            {{ formData.modifyDate }}</span
          >
        </div>
        <div class="d2-mt">
          <el-form ref="form" :model="formData">
            <el-row :gutter="20">
              <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
                <el-form-item
                  :label="$l('form_label_recommend_title') || '推荐标题'"
                  prop="recommendTitle"
                >
                  <el-input
                    :placeholder="
                      $l('form_label_recommend_title') || '推荐标题'
                    "
                    v-model="formData.recommendTitle"
                    :disabled="isViewDisabled || editType === 'edit'"
                    clearable
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
                <el-form-item
                  :label="$l('form_label_customer') || '客户名称'"
                  prop="custName"
                >
                  <dict-select
                    v-model="formData.custCode"
                    filterable
                    clearable
                    disabled
                    url="/digitalCenter/common/dict/customer"
                    size="medium"
                    :placeholder="$l('form_label_customer') || '客户名称'"
                    style="width: 100%"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
                <el-form-item
                  :label="$l('form_label_project_title') || '项目名称'"
                  prop="prjTitle"
                >
                  <el-input
                    v-model="formData.prjTitle"
                    disabled
                    clearable
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :xl="{ span: 6 }">
                <el-form-item
                  :label="$l('form_label_end_date') || '结束日期'"
                  prop="endDate"
                >
                  <el-date-picker
                    v-model="formData.endDate"
                    type="date"
                    :placeholder="$l('form_label_end_date') || '结束日期'"
                    value-format="yyyy-MM-dd"
                    size="medium"
                    :disabled="isViewDisabled"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 24 }">
                <el-form-item
                  :label="$l('form_label_recommend_desc') || '推荐说明'"
                  prop="recommendDescription"
                >
                  <el-input
                    :placeholder="$l('form_label_recommend_desc') || '推荐说明'"
                    type="textarea"
                    v-model="formData.recommendDescription"
                    maxlength="200"
                    :disabled="isViewDisabled"
                    clearable
                    rows="4"
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="d2-mt">
          <el-button-group>
            <el-button
              type="primary"
              size="mini"
              @click="addProduct"
              v-if="editType === 'edit'"
            >
              <i class="fa fa-plus"></i>
              {{ $l('btn_add_selection') || '添加选品' }}
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="exportFile"
              class="d2-mr-10"
            >
              <i class="fa fa-check"></i>
              {{ $l('btn_select_export') || '选择导出' }}
            </el-button>
            <el-button type="primary" size="mini" @click="exportAllFile">
              <i class="fa fa-arrow-down"></i>
              {{ $l('btn_all_export') || '全部导出' }}
            </el-button>
            <el-button type="primary" size="mini" @click="openPPTTemplateList">
              <i class="fa fa-download"></i>
              {{ $l('btn_export_ppt') || '导出PPT' }}
            </el-button>
          </el-button-group>
          <p></p>
          <el-table
            :data="tableData"
            ref="table"
            stripe
            style="width: 100%"
            size="small"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          >
            <el-table-column
              type="selection"
              align="center"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="deImageUrl"
              :label="$l('form_table_label_image') || '图片'"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <img
                  fit="cover"
                  :src="
                    scope.row.defaultImageUrl
                      ? scope.row.defaultImageUrl
                      : '/image/static/img/nopic.jpg'
                  "
                  style="width: 90px; height: 60px"
                />
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="left"
              :label="$l('form_table_label_sample_no') || '样品编号'"
              prop="sampleNo"
              min-width="400"
            >
              <template slot-scope="scope">
                <div>
                  {{ $l('form_table_label_sample_no') || '样品编号' }}:{{
                    scope.row.sampleNo ? scope.row.sampleNo : '--'
                  }}
                </div>
                <div>
                  {{ $l('form_table_label_name_cn') || '中文名称' }}:{{
                    scope.row.sampleName ? scope.row.sampleName : '--'
                  }}
                </div>
                <div>
                  {{ $l('form_table_label_name_en') || '英文名称' }}:{{
                    scope.row.sampleNameEn ? scope.row.sampleNameEn : '--'
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              prop="productTypeName"
              :label="$l('form_table_label_product_type') || '产品类型'"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              prop="statusName"
              :label="$l('form_table_label_status') || '状态'"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              prop="createDate"
              :label="$l('form_table_label_created_date') || '创建时间'"
              min-width="120"
            ></el-table-column>
            <div slot="empty">
              <div class="mt-60">
                <img src="/image/static/img/nodata.png" />
                <p class="no-data">
                  {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
                </p>
              </div>
            </div>
          </el-table>
          <template>
            <js-pagination
              class="mt-2"
              :current-page="page.curPage"
              :page-size="page.pageSize"
              :page-total="page.pageTotal"
              align="right"
              size="sm"
              @change="handlePaginationChange"
            />
          </template>
          <div class="d2-mt">
            <el-row>
              <el-col :span="24">
                <el-button
                  @click="save"
                  type="primary"
                  size="small"
                  v-if="!isViewDisabled"
                  >{{ $l('INDEX.btn_save') || '保存' }}</el-button
                >
              </el-col>
            </el-row>
          </div>
          <!--选择产品弹框-->
          <el-dialog
            ref="chooseMasterSampleDialog"
            :title="$l('page_dialog_title_select_product') || '选择产品'"
            :visible.sync="formOption.masterSampleVisible"
            :before-close="masterSampleCancel"
            :close-on-click-modal="false"
            width="950px"
          >
            <choose-master-sample
              ref="chooseMasterSampleForm"
              @addMasterSample="addMasterSample"
              :params="params"
            ></choose-master-sample>
          </el-dialog>
          <!--返回弹框-->
          <el-dialog
            :title="$l('INDEX.tips_question_title') || '提示信息'"
            :visible.sync="dialogVisible"
            width="30%"
          >
            <span>{{
              $l('INDEX.tips_question_save') || '是否要保存更改?'
            }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false" size="small">{{
                $l('INDEX.btn_cancel') || '取消'
              }}</el-button>
              <el-button @click="back" size="small">{{
                $l('INDEX.btn_no_save') || '不保存'
              }}</el-button>
              <el-button type="primary" @click="backSave()" size="small">{{
                $l('INDEX.btn_save') || '保存'
              }}</el-button>
            </span>
          </el-dialog>
          <!--选择PPT导出模板弹框-->
          <el-dialog
            ref="pptTemplateDialog"
            :title="$l('dialog_ppt_title') || 'PPT模板列表'"
            :visible.sync="pptTemplateDialogVisible"
            :show-close="true"
            width="1000px"
          >
            <PPTTemplate @exportPPT="exportPPT" />
          </el-dialog>
        </div>
      </el-card>
    </div>
  </b-container>
</template>
<script>
import PPTTemplate from '@/views/digital/components/ppttemplate'
import util from '@/libs/util.cookies'
import { mapActions } from 'vuex'
export default {
  components: {
    ChooseMasterSample: () => import('@/components/choose-masterSample'),
    PPTTemplate
  },
  data() {
    return {
      activeName: 'info',
      pageHeader: '我的客户推荐详情',
      isViewDisabled: false,
      dialogVisible: false,
      tableData: [],
      productList: [],
      params: {},
      formData: {
        recommendCode: '',
        recommendNo: '',
        recommendTitle: '',
        custCode: '',
        custName: '',
        recommendDescription: '',
        recommendStatus: '',
        prjCode: '',
        prjTitle: '',
        endDate: '',
        sampleNo: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: ''
      },
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      formOption: {
        title: '',
        masterSampleVisible: false
      },
      pptTemplateDialogVisible: false,
      editType: ''
    }
  },
  created() {
    this.formLoad()
  },
  activated() {
    this.formLoad()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    formLoad() {
      let recommendCode = this.$route.params.recommendCode
      let type = this.$route.params.type
      this.editType = type
      if (type === 'detail') {
        this.pageHeader = this.$l('page_title_detail') || '我的客户推荐详情'
        this.isViewDisabled = true
        this.loadDetail(recommendCode)
      } else if (type === 'edit') {
        this.isViewDisabled = false
        this.pageHeader = this.$l('page_title_edit') || '我的客户推荐编辑'
        this.loadDetail(recommendCode)
      } else if (type === 'add') {
        this.isViewDisabled = false
        this.pageHeader = this.$l('page_title_add') || '我的客户推荐新增'
        let prjInfo = JSON.parse(util.get('proInfo'))
        this.formData.recommendStatus = 'N'
        this.formData.custCode = prjInfo.custCode
        this.formData.prjCode = prjInfo.prjCode
        this.formData.prjTitle = prjInfo.prjTitle
      }
    },
    loadDetail(recommendCode) {
      let param = { recommendCode: recommendCode }
      this.$api.detailRecommendApi(param).then((res) => {
        this.formData = res.body
        this.loadTableData({ recommendCode: this.formData.recommendCode })
      })
    },
    loadTableData(form) {
      this.$api
        .detailProductListRecommendApi({
          ...(form || this.formData),
          ...this.page
        })
        .then((res) => {
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.loadTableData()
      })
    },
    changeTabs() {},
    save() {
      this.$api.saveRecommendApi(this.formData).then(() => {
        this.back()
        this.saveOkQuestion()
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          }
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    },
    back() {
      this.reset()
      if (util.get('proInfo')) {
        util.remove('proInfo')
      }
    },
    reset() {
      this.isViewDisabled = false
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.formData.recommendCode = ''
      this.editType = ''
    },
    addProduct() {
      this.formOption.masterSampleVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.chooseMasterSampleForm.load()
      }, 0)
    },
    masterSampleCancel() {
      // 取消选品弹框
      this.formOption.masterSampleVisible = false
      this.productList = []
    },
    addMasterSample() {
      // 保存勾选的选品
      let data = this.$refs.chooseMasterSampleForm.selected
      if (!data || data.length < 1) {
        this.$message.warning(this.$l('INDEX.tips_select_data') || '请选择数据')
        return
      }
      for (let i = 0; i < data.length; i++) {
        let newData = {
          productType: 'S',
          productCode: data[i].sampleCode
        }
        this.productList.push(newData)
      }
      let params = {
        recommendCode: this.formData.recommendCode,
        productList: this.productList
      }
      this.$api.productSaveRecommendApi(params).then(() => {
        this.$message.success(this.$l('INDEX.tips_save_ok') || '添加成功')
        this.loadTableData({ recommendCode: this.formData.recommendCode })
        this.masterSampleCancel()
      })
    },
    exportFile() {
      let selection = this.$refs.table.selection
      if (!selection || selection.length < 1) {
        this.$message.warning(
          this.$l('INDEX.tips_select_export_data') || '请选择需要导出的数据'
        )
        return
      }
      let sampleCodeList = []
      selection.forEach((item) => {
        sampleCodeList.push(item.sampleCode)
      })
      let param = {
        recommendCode: this.formData.recommendCode,
        sampleCodeList: sampleCodeList
      }
      let url = '/digitalCenter/shopCustomerRecommend/productExport'
      let fileName = '我的客户推荐产品明细'
      this.$api.globalExportData(url, param, fileName)
    },
    exportAllFile() {
      let param = {
        recommendCode: this.formData.recommendCode
      }
      let url = '/digitalCenter/shopCustomerRecommend/productExport'
      let fileName = '我的客户推荐产品明细'
      this.$api.globalExportData(url, param, fileName)
    },
    openPPTTemplateList() {
      let selection = this.$refs.table.selection
      if (selection && selection.length < 1) {
        this.$message.warning(
          this.$l('tips_select_product_data') || '请选择产品!'
        )
        return
      }
      this.pptTemplateDialogVisible = true
    },
    exportPPT(val) {
      let selection = this.$refs.table.selection
      let param = {
        recommendCode: this.formData.recommendCode,
        templateCode: val.templateCode,
        templateName: val.templateName,
        sampleData: selection.map((item) => {
          return {
            sampleCode: item.sampleCode,
            sourceType: 'sample'
          }
        })
      }
      let addDowndloadTaskParam = {
        bizType: 'exportRecommendPPT',
        bizParams: param,
        downloadFileName: this.formData.custName
      }

      // console.log(addDowndloadTaskParam)

      this.$api.addDownloadTaskApi(addDowndloadTaskParam).then((res) => {
        this.$message({
          showClose: true,
          // message: this.$l("tips_save_ok") || "下载任务提交成功！",
          message: '下载任务提交成功！',
          type: 'success'
        })
      })
    }
  }
}
</script>
